module.exports = {
  server: window.location.href.includes("localhost")
    ? "http://localhost:8000"
    : "https://api.hostarena.org",

  CLOUD_COUPON_DOMAIN: "https://cloudcoupons.net/",
  EMAIL_USERNAME: "evans.gaylord@ethereal.email",
  EMAIL_PASSWORD: "kX1XdY1WeahFyS4j75",
};
